// extracted by mini-css-extract-plugin
export default {"verticalTabItem":"VerticalTabItemOverride_verticalTabItem__C4LGZ","icon":"VerticalTabItemOverride_icon__K04EH"};